import React from 'react'
import { object, bool, string } from 'prop-types'
import { Helmet } from 'react-helmet'
import { EMPTY_OBJECT } from '../../utils/constants'
import { urlPathToObject, objectToUrlPath } from '../../helpers/common'

const CANONICAL = 'canonical'
const renderMetaNoIndex = <meta name='robots' content='noindex' />

const formatFilters = filters => {
  // we're omitting the first element because it interferes when taking pairs
  const {
    expertise, country, categories, offices, companies, year, materials, color, bim, properties,
    productType, use, imageType, space, buildingElement, fixturesAndFurniture, environment
  } = filters.split('/').slice(1).reduce((obj, _, idx, elements) => {
    if (idx % 2 === 1) return obj

    obj[elements[idx]] = elements[idx + 1] || null
    return obj
  }, {})

  return [
    country && `/country/${country}`,
    expertise && `/expertise/${expertise}`,
    categories && `/categories/${categories}`,
    offices && `/offices/${offices}`,
    companies && `/companies/${companies}`,
    year && `/year/${year}`,
    materials && `/materials/${materials}`,
    color && `/color/${color}`,
    bim && `/bim/${bim}`,
    properties && `/properties/${properties}`,
    productType && `/product_type/${productType}`,
    use && `/use/${use}`,
    imageType && `/image_type/${imageType}`,
    space && `/space/${space}`,
    buildingElement && `/building_element/${buildingElement}`,
    fixturesAndFurniture && `/fixtures_and_furniture/${fixturesAndFurniture}`,
    environment && `/environment/${environment}`
  ].join('')
}

const MetaData = ({ metadata = EMPTY_OBJECT, shouldSetNoIndex, type, site }) => {
  const { origin } = document.location

  const filtersObject = urlPathToObject(location, type)
  const filters = objectToUrlPath(filtersObject, type)
  const route = site === 'us' ? `/search/${type}` : `/search/${site}/${type}`
  const filtersFormatted = formatFilters(filters)
  const canonicalUrl = `${origin}${route}${filtersFormatted}`

  return (
    <Helmet>
      {metadata.title && <title>{metadata.title}</title>}
      <link rel={CANONICAL} href={canonicalUrl} />
      {shouldSetNoIndex && renderMetaNoIndex}
      {metadata.metadescription && <meta name='description' content={metadata.metadescription} />}
      {metadata.metadescription && <meta property='og:description' content={metadata.metadescription} />}
    </Helmet>
  )
}

MetaData.propTypes = {
  metadata: object,
  shouldSetNoIndex: bool,
  type: string,
  site: string
}

export default MetaData
